import { BRAINTREE_TOKEN } from 'utils/globals';

import dataCollector from 'braintree-web/data-collector';
import client, { Client } from 'braintree-web/client';
import hostedFields, { HostedFields } from 'braintree-web/hosted-fields';
import { ApplePay, applePay } from 'braintree-web';

class BraintreeClient {
  btclient?: Client;
  hf?: HostedFields;
  applePay?: ApplePay;
  deviceData: string;
  error?: Error;

  cardholderId = 'braintree-card-cardholder';
  numberId = 'braintree-card-number';
  expirationId = 'braintree-cart-expiration';
  cvvId = 'braintree-card-cvv';
  postalId = 'braintree-card-postal';

  constructor() {
    client.create({ authorization: BRAINTREE_TOKEN }, (err, instance) => {
      if (err) {
        this.error = err;
      } else {
        this.btclient = instance;
      }
    });
  }

  async initHostedFields(onSubmit: () => void) {
    if (!this.btclient) {
      const error = this.error || new Error('No Braintree Client');
      throw error;
    }

    const dc = await dataCollector.create({ client: this.btclient });
    this.deviceData = dc.deviceData;

    if (!this.deviceData) {
      throw new Error('No Braintree Device Data');
    }

    this.hf = await hostedFields.create({
      client: this.btclient,
      styles: {
        input: {
          color: '#FFF',
        },
      },
      fields: {
        cardholderName: {
          container: `#${this.cardholderId}`,
        },
        number: {
          container: `#${this.numberId}`,
        },
        expirationDate: {
          container: `#${this.expirationId}`,
        },
        cvv: {
          container: `#${this.cvvId}`,
        },
        postalCode: {
          container: `#${this.postalId}`,
        },
      },
    });

    this.hf.on('inputSubmitRequest', onSubmit);
  }

  async initApplePay() {
    if (!this.btclient) {
      const error = this.error || new Error('No Braintree Client');
      throw error;
    }

    if (!this.applePay) {
      this.applePay = await applePay.create({
        client: this.btclient,
      });
    }

    const dc = await dataCollector.create({ client: this.btclient });
    this.deviceData = dc.deviceData;

    if (!this.deviceData) {
      throw new Error('No Braintree Device Data');
    }
  }
}

export const braintreeClient = new BraintreeClient();
